import Vue from "vue";
import iView from "view-design";
import Clipboard from "clipboard";

let aips = "";
// 投审稿后台地址
let getBaseUrl = () => {
  let url = "";
  if (
    location.host.indexOf("dev.") != -1 ||
    location.host.indexOf("127.") != -1 ||
    location.host.indexOf("8080") != -1
  ) {
    url = "https://tsgadmintest.cnknowledge.com/tsg-admin"; // 投审稿测试环境
  } else if (location.host.indexOf("yutsg") != -1) {
    // url = "http://112.126.62.29:8093/tsg-admin"; // 投审稿预生产环境
    url = "https://tsgadminyu.cnknowledge.com/tsg-admin"
  } else {
    url = "https://tsgadmin.cnknowledge.com/tsg-admin"; // 投审稿正式环境
  }
  return url;
};
// 中文知识网地址
let getCnkUrl = () => {
  let url = "";
  if (
    location.host.indexOf("dev.") != -1 ||
    location.host.indexOf("127.") != -1 ||
    location.host.indexOf("8080") != -1
  ) {
    // url = "http://47.93.50.49:5052"; // 中文知识网测试环境
    url = "https://wxtest.cnknowledge.com"
  } else if (location.host.indexOf("yutsg") != -1) {
    // url = "http://112.126.62.200:5052"; // 中文知识网预生产环境
    url = "https://zwiii.cnknowledge.com"
  } else {
    url = "https://zwi.cnknowledge.com"; // 中文知识网正式环境
  }
  return url;
};
// 投审稿作者端地址
let getAuthorUrl = () => {
  let url = "";
  if (
    location.host.indexOf("dev.") != -1 ||
    location.host.indexOf("127.") != -1 ||
    location.host.indexOf("8080") != -1
  ) {
    // url = "http://47.93.50.49:8092"; // 投审稿作者端测试环境
    url = "https://tsgauthortest.baikezaixian.com"
  } else if (location.host.indexOf("yutsg") != -1) {
    // url = "http://112.126.62.29:8092"; // 投审稿作者端预生产环境
    url = "https://tsgauthoryu.cnknowledge.com"
  } else {
    url = "https://tsgauthor.cnknowledge.com"; // 投审稿作者端正式环境
  }
  return url;
};
// 图片地址
let getImgUrl = () => {
  let url = "";
  if (
    location.host.indexOf("dev.") != -1 ||
    location.host.indexOf("127.") != -1 ||
    location.host.indexOf("8080") != -1
  ) {
    url = "https://fdfs.cnknowledge.com/"; // 图片测试环境
  } else if (location.host.indexOf("yutsg") != -1) {
    url = "https://ljw.cnknowledge.com/"; // 图片预生产环境
  } else {
    url = "https://kpp.cnknowledge.com/"; // 图片正式环境
  }
  return url;
};
let getParam = function getParam() {
  var search = {};
  try {
    location.search
      .substr(1)
      .split("&")
      .forEach(function (item) {
        var s = item.split("=");
        search[s[0]] = s[1];
      });
  } catch (e) {
    // 抛出异常
    throw new Error(JSON.stringify(search));
  }
  return search;
};

let setParam = function setParam(param) {
  let str = "";
  for (let key in param) {
    str += "&" + key + "=" + param[key];
  }
  str = str.replace(/\&/, "?");
  str = str.replaceAll(undefined, "");
  return str;
};

if (location.href.indexOf(":80") != -1) {
  aips = "/apis";
}

let session = JSON.parse(sessionStorage.getItem("userInfo")) || {};
var global = {
  url: getBaseUrl(),
  url2: "http://web.tonghangpingyi.com/txpy-web", //同行评议
  url3: getCnkUrl(),
  url4: getAuthorUrl(),
  imgUrl: getImgUrl(),
  authorUrl: "http://39.105.8.131:8092/tsg-author",
  getParam: getParam, // 获取url参数返回json
  setParam: setParam,

  // v3.0.3 处理二级权限菜单
  levelTwoPermissionList(levelOneName) {
    // 获取权限列表
    var menuList = JSON.parse(window.sessionStorage.getItem("menuList"));
    var twoList = [];
    for (var i in menuList) {
      if (menuList[i].menuName.replace(/\s/g, "") == levelOneName) {
        twoList = menuList[i].twoList;
        break;
      }
    }
    // 返回二级菜单名列表
    return twoList.map((item) => item.menuName);
  },
  checkPhone(value) {
    //验证手机号
    if (value == "") {
      iView.Message.destroy();
      setTimeout(function () {
        iView.Message.warning("手机号不能为空");
      }, 500);
      return false;
    }
    if (!/^1[3456789]\d{9}$/.test(value)) {
      iView.Message.destroy();
      setTimeout(function () {
        iView.Message.warning("手机号格式不对");
      }, 500);
      return false;
    }
    return true;
  },
  transferDate(times) {
    // v.2.8.1 接口响应数据变化，改为字符串时间戳，需要转换为number
    times = Number(times) ? Number(times) : times;
    //时间戳转时间
    var date = new Date(times);
    var Y = date.getFullYear() + "-";
    var M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
    var h =
      (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
    var m =
      (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      ":";
    var s =
      date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    return Y + M + D + h + m + s;
  },
  transferYear(times) {
    // v.2.8.1 接口响应数据变化，改为字符串时间戳，需要转换为number
    times = Number(times) ? Number(times) : times;
    //时间戳转时间年月日
    var date = new Date(times);
    var Y = date.getFullYear() + "-";
    var M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    return Y + M + D;
  },
  getYear(times) {//时间戳转时间年月
    if (!times) return '';
    var date = new Date(times);
    var Y = date.getFullYear();
    return String(Y);
  },
  transferMonth(times) {
    // v.2.8.1 接口响应数据变化，改为字符串时间戳，需要转换为number
    times = Number(times) ? Number(times) : times;
    //时间戳转时间年月
    var date = new Date(times);
    var Y = date.getFullYear() + "-";
    var M =
      date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1;
    return Y + M;
  },
  //深拷贝
  deepClone(obj) {
    let _tmp = JSON.stringify(obj); //将对象转换为json字符串形式
    let result = JSON.parse(_tmp); //将转换而来的字符串转换为原生js对象
    return result;
  },
  transYear(times) {
    // v.2.8.1 接口响应数据变化，改为字符串时间戳，需要转换为number
    times = Number(times) ? Number(times) : times;
    //时间戳转时间年
    var date = new Date(times);

    var Y = date.getFullYear();
    return Y;
  },
  time(date) {
    if (date == null) {
      return;
    } else {
      date = Number(date) ? Number(date) : date;
      var dateee = new Date(date).toJSON();
      return new Date(+new Date(dateee) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, " ")
        .replace(/\.[\d]{3}Z/, "");
    }
  },
  transferTime(times) {
    // v.2.8.1 接口响应数据变化，改为字符串时间戳，需要转换为number
    times = Number(times) ? Number(times) : times;
    //时间转时间戳
    return new Date(times).getTime();
  },
  copyArr(arr) {
    //拷贝数组
    return Object.assign([], arr);
  },
  copyObj(obj) {
    //拷贝对象
    return Object.assign({}, obj);
  },
  repeatNo(obj) {
    // let arr=[...new Set(obj)]
    return Array.from(new Set(obj));
  },
  copy(mobile) {
    var Url = mobile;
    var clipboard = new Clipboard(".tag-read", {
      text: function () {
        return Url;
      },
    });
    clipboard.on("success", (e) => {
      iView.Message.success("复制成功");
      // 释放内存
      clipboard.destroy();
    });
    clipboard.on("error", (e) => {
      // 不支持复制
      iView.Message.destroy();
      setTimeout(function () {
        iView.Message.warning("该浏览器不支持自动复制");
      }, 500);
      // 释放内存
      clipboard.destroy();
    });
  },
  getIndexPath(userType) {
    if (userType == "ROLE_FINANCE") {
      var path = "/finance/index";
    } else {
      var path = "/manage/welcome";
    }
    return path;
  },
  sortByKey(array, key) {
    //(数组、排序的列)
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  },
  payMethod(status) {
    if (status == "WXPay") {
      status = "微信";
    } else if (status == "Alipay 2.0") {
      status = "支付宝";
    } else if (status == "ACP") {
      status = "银联闪付";
    } else {
      status = "无";
    }
    return status;
  },
  saveUserInfo(info) {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo")); //取出sesion
    userInfo.info = info;
    var jsonStr = JSON.stringify(userInfo);
    sessionStorage.setItem("userInfo", jsonStr); //将用户信息存入sesion
  },
  getUserInfo(type) {
    
    return JSON.parse(sessionStorage.getItem("userInfo")).info[type];
  },
  escape(str) {
    str = str.replace(/&/g, "%26");
    return str;
  },
  publishPeriod(num) {
    let data = [
      {
        name: "年刊",
      },
      {
        name: "半年刊",
      },
      {
        name: "季刊",
      },
      {
        name: "双月刊",
      },
      {
        name: "月刊",
      },
      {
        name: "半月刊",
      },
      {
        name: "旬刊",
      },
      {
        name: "周刊",
      },
      {
        name: "周二刊",
      },
    ];
    return data[num - 1].name;
  },
  //开票状态
  invoiceStatus(status) {
    let data = [
      {
        name: "待开票",
      },
      {
        name: "待开票",
      },
      {
        name: "已开发票",
      },
      {
        name: "需要未开",
      },
      {
        name: "无需开票",
      },
      {
        name: "过期未开",
      },
      {
        name: "已处理",
      },
    ];
    return data[status - 1].name;
  },
  //订单类型
  feeTypes(num) {
    let data = [
      {
        name: "预付费用",
      },
      {
        name: "其他费用",
      },
      {
        name: "录用费用",
      },
      {
        name: "加急费",
      },
      {
        name: "增版费",
      },
      {
        name: "查重费",
      },
    ];
    return data[num - 1].name;
  },
  //支付方式
  feeType(status) {
    if (status == "WXPay") {
      status = "微信";
    } else if (status == "Alipay 2.0") {
      status = "支付宝";
    } else if (status == "ACP") {
      status = "银联闪付";
    } else {
      status = "无";
    }
    return status;
  },
  //订单状态
  payStatus(ststus, type) {
    if (ststus == 0) {
      ststus = "未支付/待退款";
    } else if (ststus == 1) {
      ststus = "已支付";
    } else if (ststus == 2) {
      ststus = "已取消";
    } else if (ststus == 3) {
      ststus = "已关闭";
    } else if (ststus == 4) {
      ststus = "已退款";
    } else {
      ststus = "审核中";
    }
    return ststus;
  },
  //审核状态
  reviewStatus(status) {
    switch (status) {
      case 0:
        status = "管理员待审核";
        break;
      case 1:
        status = "管理员已拒绝";
        break;
      case 2:
        status = "财务待审核";
        break;
      case 3:
        status = "财务已拒绝";
        break;
      case 4:
        status = "已退款";
        break;
    }
    return status;
  },
  //稿件状态
  articleStatus(status) {
    switch (status) {
      case 0:
        status = "作者未支付";
        break;
      case 1:
        status = "初审分配";
        break;
      case 10:
        status = "初审";
        break;
      case 15:
        status = "筛稿分配";
        break;
      case 16:
        status = "筛稿";
        break;
      case 20:
        status = "查重";
        break;
      case 30:
        status = "复审分配";
        break;
      case 40:
        status = "复审";
        break;
      case 50:
        status = "外审分配";
        break;
      case 60:
        status = "外审";
        break;
      case 65:
        status = "终审分配";
        break;
      case 70:
        status = "终审";
        break;
      case 80:
        status = "录用确认";
        break;
      case 90:
        status = "录用";
        break;
      case 100:
        status = "排期";
        break;
      case 110:
        status = "发排";
        break;
      case 120:
        status = "初排";
        break;
      case 130:
        status = "一校";
        break;
      case 140:
        status = "一改";
        break;
      case 150:
        status = "二校";
        break;
      case 160:
        status = "二改";
        break;
      case 170:
        status = "三校";
        break;
      case 180:
        status = "三改";
        break;
      case 181:
        status = "四校";
        break;
      case 182:
        status = "四改";
        break;
      case 183:
        status = "五校";
        break;
      case 184:
        status = "五改";
        break;
      case 185:
        status = "六校";
        break;
      case 186:
        status = "六改";
        break;
      case 187:
        status = "七校";
        break;
      case 188:
        status = "七改";
        break;
      case 189:
        status = "八校";
        break;
      case 191:
        status = "八改";
        break;
      case 190:
        status = "出片";
        break;
      case 200:
        status = "改片";
        break;
      case 205:
        status = "确认校样";
        break;
        case 209:
          status = "付印";
          break;
      case 210:
        status = "印刷";
        break;
      case 220:
        status = "邮寄";
        break;
      case 230:
        status = "已刊发";
        break;
      case 240:
        status = "存档";
        break;
      case 250:
        status = "审读";
        break;
      case 251:
        status = "改红";
        break;
      case 252:
        status = "审读";
        break;
      case 253:
        status = "改红";
        break;
      case 254:
        status = "审读";
        break;
      case 255:
        status = "改红";
        break;
      case 256:
        status = "审读";
        break;
      case 257:
        status = "改红";
        break;
      case 258:
        status = "审读";
        break;
      case 259:
        status = "改红";
        break;
      case 260:
        status = "审读";
        break;
      case 261:
        status = "改红";
        break;
      case 262:
        status = "审读";
        break;
      case 263:
        status = "改红";
        break;
      case 264:
        status = "审读";
        break;
      case 265:
        status = "改红";
        break;
      case 300:
        status = "退修";
        break;
      case 350:
        status = "退修中";
        break;
      case 400:
        status = "退稿";
        break;
      case 450:
        status = "退稿中";
        break;
      case 600:
        status = "基金审核";
        break;
    }
    return status;
  },
  //外审分配状态
  auditStatus(status) {
    switch (status) {
      case 0:
        status = "待分配";
        break;
      case 1:
        status = "待审核";
        break;
      case 2:
        status = "部分已审核";
        break;
      case 3:
        status = "全部已审核";
        break;
      case 4:
        status = "已关闭";
        break;
      case 5:
        status = "待分配";
        break;
    }
    return status;
  },
  //基金等级
  fundLevelList(status) {
    switch (status) {
      case 1:
        status = "国际级";
        break;
      case 2:
        status = "国家级";
        break;
      case 3:
        status = "省级";
        break;
      case 4:
        status = "市、院、校级";
        break;
      case 5:
        status = "县级及其他";
        break;
    }
    return status;
  },
  // 订单类型
  // 订单类型。1预付费用，2其他费用，3录用费用,4加急费，5增版费
  orderType(status) {
    switch (status) {
      case 1:
        status = "预付费用";
        break;
      case 2:
        status = "其他费用";
        break;
      case 3:
        status = "录用费用";
        break;
      case 4:
        status = "加急费";
        break;
      case 5:
        status = "增版费";
        break;
      case 6:
        status = "查重费";  
        break;
    }
    return status;
  },
  examineStatus(status) {
    switch (status) {
      case 0:
        status = "未提交";
        break;
      case 1:
        status = "提交未审核";
        break;
      case 2:
        status = "审核通过";
        break;
      case 3:
        status = "审核未通过";
        break;
    }
    return status;
  },
  adminType(status) {
    if (status == "ROLE_FINANCE") {
      status = 1;
    }
    if (status == "ROLE_ADMIN") {
      status = 2;
    }
    if (status == "ROLE_EDIT") {
      status = 3;
    }
    return status;
  },
  // 审稿费状态
  auditFeeStatus(status) {
    switch (status) {
      case 0:
        status = "无";
        break;
      case 1:
        status = "未支付";
        break;
      case 2:
        status = "待支付";
        break;
      case 3:
        status = "已支付";
        break;
    }
    return status;
  },

  // 消息类型
  msgTypeName(status) {
    switch (status) {
      case 1:
        status = "优惠审核";
        break;
      case 2:
        status = "退修审核";
        break;
      case 3:
        status = "稿件补充附件";
        break;
      case 4:
        status = "稿件录用";
        break;
      case 5:
        status = "稿件撤稿";
        break;
      case 6:
        status = "稿件退稿";
        break;
      case 7:
        status = "作者校样";
        break;
      case 8:
        status = "作者校样反馈";
        break;
      case 9:
        status = "稿件退修";
        break;
      case 10:
        status = "审稿退回";
        break;
      case 11:
        status = "补充附件完成";
        break;
    }
    return status;
  },
  //校对状态
  proofread(status) {
    switch (status) {
      case 3:
        status = "三校三改";
        break;
      case 4:
        status = "四校四改";
        break;
      case 5:
        status = "五校五改";
        break;
      case 6:
        status = "六校六改";
        break;
      case 7:
        status = "七校七改";
        break;
      case 8:
        status = "八校八改";
        break;
    }
    return status;
  },
  //校对状态
  sxProofread(status) {
    switch (status) {
      case 1:
        status = "一审一改";
        break;
      case 2:
        status = "二审二改";
        break;
      case 3:
        status = "三审三改";
        break;
      case 4:
        status = "四审四改";
        break;
      case 5:
        status = "五审五改";
        break;
      case 6:
        status = "六审六改";
        break;
      case 7:
        status = "七审七改";
        break;
      case 8:
        status = "八审八改";
        break;
    }
    return status;
  },
  readChange(status) {
    switch (status) {
      case 250:
        status = "一审";
        break;
      case 251:
        status = "一改";
        break;
      case 252:
        status = "二审";
        break;
      case 253:
        status = "二改";
        break;
      case 254:
        status = "三审";
        break;
      case 255:
        status = "三改";
        break;
      case 256:
        status = "四审";
        break;
      case 257:
        status = "四改";
        break;
      case 258:
        status = "五审";
        break;
      case 259:
        status = "五改";
        break;
      case 260:
        status = "六审";
        break;
      case 261:
        status = "六改";
        break;
      case 262:
        status = "七审";
        break;
      case 263:
        status = "七改";
        break;
      case 264:
        status = "八审";
        break;
      case 265:
        status = "八改";
        break;
    }
    return status;
  },
  // v2.7.2 专家绩效查询当月，上个月，指定日期，需转换 yyyy-MM
  /* 参数为起止日期对象，range用于区分当月或上个月 current/last/custom  只有自定义custom需传起止日期*/

  expertsPerformanceDateFormat(
    range = "current",
    startDate = null,
    endDate = null
  ) {
    var startY,
      startM,
      startD,
      endY,
      endM,
      endD,
      dateArr = [];
    if (range != "custom") {
      // 查询当月或上月
      // 转换当月日期格式
      var currentDate = new Date();
      startY = currentDate.getFullYear();
      startM = currentDate.getMonth() + 1; // 0-11 -> 1-12
      startD = "01";
      endD = currentDate.getDate()
      if (range == "last") {
        // 查询上月，检测月份是否是1月 (平闰年 当月为3月查询2月，还需校验day : yyyy-03-31 查询上月 yyyy - 02 -31，此处查询当月或上月后端不需要day,校验暂不实现)
        startM--;
        if (startM == 0) {
          startY--;
          startM = 12;
        }
        if ([1, 3, 5, 7, 8, 10, 12].indexOf(startM) != -1) {
          endD = "31"
        } else if ([4, 6, 9, 11].indexOf(startM) != -1) {
          endD = "30"
        } else if (startM == 2) {
          if ((startY % 100 != 0 && startY % 4 == 0) || startY % 400 == 0) {
            endD = 29
          } else {
            endD = 28;
          }
        }
      }

      // 转两位月
      startM = startM < 10 ? "0" + startM : startM;
      dateArr.push(`${startY}-${startM}-${startD}`, `${startY}-${startM}-${endD}`);
    } else {
      // 查询自定义，接收startDate,endDate
      startDate = new Date(startDate);
      var customStartY = startDate.getFullYear();
      var customStartM = startDate.getMonth() + 1;
      var customStartD = startDate.getDate();
      customStartM = customStartM < 10 ? "0" + customStartM : customStartM;

      endDate = new Date(endDate);
      var customEndY = endDate.getFullYear();
      var customEndM = endDate.getMonth() + 1;
      var customEndD = endDate.getDate();
      customEndM = customEndM < 10 ? "0" + customEndM : customEndM;

      dateArr.push(
        `${customStartY}-${customStartM}-${customStartD}`,
        `${customEndY}-${customEndM}-${customEndD}`
      );
    }

    return dateArr;
  },


  /* 判断数组多区间间是否重合
* @param area
* @returns {number}   返回值 0-正常 1-区间重合 2-最小值大于最大值 3-区间没有连续
*/

  checkIfArrayIntervalOverLap(list) {
    let result = 0
    let listLength = list.length
    if (listLength > 0) {
      let maxStartArr = []
      let minEndArr = []
      let minStart1 = 0
      let minStart2 = 0
      let maxEnd1 = 0
      let maxEnd2 = 0
      let secondResult = false
      let seriesNumber = 0
      let newMaxEnd = 0
      for (let i = 0; i < listLength; i++) {
        minStart1 = list[i][0]
        maxEnd1 = list[i][1]
        secondResult = false
        seriesNumber = 0
        // 判断最小值是否大于最大值
        if (minStart1 > maxEnd1 && maxEnd1 !== 0) {
          result = 2
          break;
        }
        for (let t = 0; t < listLength; t++) {
          minStart2 = list[t][0]
          maxEnd2 = list[t][1]
          if (i !== t) { // 不与自身比  
            maxStartArr = [minStart1, minStart2];// 开始课时数组
            minEndArr = [maxEnd1, maxEnd2];// 结束课时数组
            newMaxEnd = Number(maxEnd1 + 1);
            // 判断数字是否连续
            if (newMaxEnd === minStart2) {
              seriesNumber = seriesNumber + 1;
            }
            // 判断是否有重合区间
            if (Math.max(...maxStartArr) <= Math.min(...minEndArr)) {
              secondResult = true
              result = 1
              break;
            }
          }
        }
        // 判断是否有重合区间返回结果
        if (secondResult === true) {
          break;
        }
        // 判断区间是否连续
        if (seriesNumber !== 1 && i !== listLength - 1) {
          result = 3
          break;
        }

      }
    }

    return result
  },

  /* 小数四舍五入
* @param number 需要四舍五入的数据
* @param precision 指定小数位数
* @returns 例如 round(1.005, 2); //1.01
*/
 round(number, precision) {
    return Math.round(+number + "e" + precision) / Math.pow(10, precision); 
  }
  

  
};

// 注册插件全局通用
export default {
  install() {
    Vue.prototype.$global = global;
  },
  global,
};



// WEBPACK FOOTER //
// ./src/core/global/global.js